import { type GetMsgFunction } from './i18n.types';

export const getBaseMsgs: GetMsgFunction = async ({ langCode }) => {
  let msgModule;

  try {
    msgModule = (await import(`./${langCode}/base.json`)).default;
  } catch (_error) {
    msgModule = {};
  }

  return msgModule;
};

export const getPageMsgs: GetMsgFunction = async (options) => {
  let msgModule;

  try {
    msgModule = (await import(`./${options.langCode}/${options.pageName}.json`))
      .default;
  } catch (_error) {
    msgModule = {};
  }

  return msgModule;
};
